console.log('components');
import './components/gsap-appearence.js';
import './components/burger.js';
import './components/swiper.js';
import './components/search.js';

